/* 
 *  This file global-region.model.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2025  
 *  (C) 2015-2025. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { PaginationModel, LinksModel } from '../../../../../global/models/common.models';
import { FormControl } from '@angular/forms';

export enum globalRegionUrls {
    globalRegionList = '/api/core/GlobalRegion',
    globalRegionSearch = '/api/core/GlobalRegion/Search',
    globalRegionInsert = '/api/core/GlobalRegion',
    globalRegionUpdate = '/api/core/GlobalRegion',
    globalRegionDelete = '/api/core/GlobalRegion',
    employeeCount = '/api/core/GlobalRegion/EmployeeCount',
    totalCount = '/api/core/GlobalRegion/TotalCount'
}

export interface GlobalRegionGridRequestModel {
    globalRegionCode: string;
    status: string;
    pagination: PaginationModel;
}

export const globalRegionGridRequestData: GlobalRegionGridRequestModel = {
    globalRegionCode: '',
    status: '1',
    pagination: {
        pageNumber: 1,
        pageSize: 15
    }
};

export interface GlobalRegionModel {
    globalRegionCode?: string;
    globalRegionName?: string;
    activeStatus?: string;
}

export interface GlobalRegionGridResponseModel {
    countryCode?: string;
    countryName?: string;
    internationalCode?: string;
    nationality?: string;
    activeStatus?: string;
    globalRegionId?: number;
    globalRegionName?: string;
    globalRegionCode?: string;
    links?: LinksModel[];
    employeeCountLink?: string;
    employeeCount?: string;
}

export interface GlobalRegionSearchResponseModel {
    countryCode?: string;
    countryName?: string;
    internationalCode?: string;
    nationality?: string;
    activeStatus?: string;
    globalRegionId?: number;
    globalRegionName?: string;
    links?: LinksModel[];
}

export const globalRegionFormEmptyData: GlobalRegionModel = {
    globalRegionCode: '',
    globalRegionName: '',
    activeStatus: '1'
};

export interface GlobalRegionFilterModel {
    selected_global_region: Array<{ key: string; value: string }>;
    active: boolean;
    inactive: boolean;
}

export const globalRegionFilterSkeleton: GlobalRegionFilterModel = {
    selected_global_region: [] as Array<{ key: string; value: string }>,
    active: true,
    inactive: false
};

// Form interface for type safety
export interface GlobalRegionFormInterface {
    globalRegionCode: FormControl<string | null>;
    globalRegionName: FormControl<string | null>;
    activeStatus: FormControl<string | null>;
}

// Interface for dropdown options
export interface DropdownOption {
    key: string;
    value: string;
}

// Interface for button config
export interface ButtonConfig {
    text: string;
    index: number;
}

// Interface for confirm dialog
export interface ConfirmDialog {
    show: boolean;
}

// Interface for access rights
export interface AccessRights {
    view: boolean;
    add: boolean;
    update: boolean;
    delete: boolean;
}
